import { browser } from '$app/environment';
import { init, register, waitLocale } from 'svelte-i18n';

const defaultLocale = 'en';
const supportedLocales = ['en', 'es', 'fr', 'de', 'pt', 'it', 'ru', 'zh', 'ja', 'ko'];

register('en', () => import('./locales/en.json'));
register('es', () => import('./locales/es.json'));
register('fr', () => import('./locales/fr.json'));
register('de', () => import('./locales/de.json'));
register('pt', () => import('./locales/pt.json'));
register('it', () => import('./locales/it.json'));
register('ru', () => import('./locales/ru.json'));
register('zh', () => import('./locales/zh.json'));
register('ja', () => import('./locales/ja.json'));
register('ko', () => import('./locales/ko.json'));

let initialLocale = defaultLocale;

if (browser) {
  // Check for stored language preference first
  const stored = localStorage.getItem('preferred-language');
  if (stored && supportedLocales.includes(stored)) {
    initialLocale = stored;
  } else {
    // Use browser language as fallback
    const browserLang = window.navigator.language.split('-')[0];
    if (supportedLocales.includes(browserLang)) {
      initialLocale = browserLang;
    }
  }
}

init({
  fallbackLocale: defaultLocale,
  initialLocale: initialLocale,
  loadingDelay: 200,
});

export { waitLocale, supportedLocales };
